import DescriptionPaneTextEditor from './DescriptionPaneTextEditor';

export default DescriptionPaneTextEditor;
export { DescriptionPaneTextEditor };
